export interface Partner {
  partner_id?: string;
  name: string;
  system_name: string;
  refersion_id: string;
  active: boolean;
  created?: Date;
  updated?: Date;
  product_count?: number;
}

export interface PartnerErrors {
  name: boolean;
  system_name: boolean;
  refersion_id: boolean;
  active: boolean;
}

export enum PARTNER_FIELDS {
  name = 'name',
  system_name = 'system_name',
  refersion_id = 'refersion_id',
  active = 'active'
}

export type PartnerType = Partner;
